import React, { FC } from 'react';
import classNames from 'classnames';
import { Asset, Pill, PricetagIcon } from '@clearcover/atlas';
import styles from './styles.module.css';

type DiscountBadgeProps = {
  className?: string;
};

export const DiscountBadge: FC<DiscountBadgeProps> = ({
  children,
  className,
}) => {
  return (
    <Pill variant="success" className={classNames(styles.wrapper, className)}>
      <Asset
        icon={PricetagIcon}
        description="discount-pricetag-icon"
        height={12}
        width={12}
      />
      {children}
    </Pill>
  );
};
